import _ from 'lodash'

const LANGUAGE_CONFIG = {
  hu: {
    steps: ['RoofType', 'Measurements', 'TileShape', 'Tiles', 'SummaryStep'],
    minDegree: 15,
    showBanners: true,
    hasEnvirosense: true,
    hasTetotepitek: false,
    hasWoodMaterials: true,
    hasTudastar: true,
    hasCetelem: false,
    hasGutter: true,
    hasGeneron: true,
    hasGallery: false
  },
  sk: {
    steps: ['RoofType', 'Measurements', 'TileShape', 'Tiles', 'Questions', 'SummaryStep'],
    minDegree: 10,
    showBanners: true,
    hasEnvirosense: false,
    hasTetotepitek: false,
    hasWoodMaterials: false,
    hasTudastar: false,
    hasCetelem: false,
    hasGutter: false,
    hasGeneron: false,
    hasGallery: false
  },
  sr: {
    steps: ['RoofType', 'Measurements', 'Package', 'TileShape', 'Tiles', 'SummaryStep'],
    minDegree: 15,
    showBanners: false,
    hasEnvirosense: false,
    hasTetotepitek: false,
    hasWoodMaterials: false,
    hasTudastar: false,
    hasCetelem: false,
    hasGutter: false,
    hasGeneron: false,
    hasGallery: false
  },
  hr: {
    steps: ['RoofType', 'Measurements', 'Package', 'TileShape', 'Tiles', 'SummaryStep'],
    minDegree: 15,
    showBanners: true,
    hasEnvirosense: false,
    hasTetotepitek: false,
    hasWoodMaterials: false,
    hasTudastar: false,
    hasCetelem: false,
    hasGutter: false,
    hasGeneron: false,
    hasGallery: false
  },
  ro: {
    steps: ['RoofType', 'Measurements', 'TileShape', 'Tiles', 'SummaryStep'],
    minDegree: 15,
    showBanners: false,
    hasEnvirosense: false,
    hasTetotepitek: false,
    hasWoodMaterials: false,
    hasTudastar: false,
    hasCetelem: false,
    hasGutter: false,
    hasGeneron: false,
    hasGallery: false
  }
}
const LANGUAGE_KEY = 'language'

function getCurrentLanguageFromDomain() {
  const FALLBACK_LANGUAGE = process.env.VUE_APP_DEFAULT_LOCALE
  const URL_MAP = [
    {
      language: 'hu',
      staging: 'staging-kalkulator.terranteto.hu',
      production: 'kalkulator.terranteto.hu'
    },
    {
      language: 'sk',
      staging: 'staging-kalkulator.terran.sk',
      production: 'kalkulator.terran.sk'
    },
    {
      language: 'sr',
      staging: 'staging-kalkulator.terran.rs',
      production: 'kalkulator.terran.rs'
    },
    {
      language: 'hr',
      staging: 'staging-kalkulator.terran.hr',
      production: 'kalkulator.terran.hr'
    },
    {
      language: 'ro',
      staging: 'staging-calculatoracoperis.tigleterran.ro',
      production: 'calculatoracoperis.tigleterran.ro'
    }
  ]

  const currentLanguage = _.result(
    _.find(URL_MAP, url => url[process.env.NODE_ENV] === window.location.host),
    LANGUAGE_KEY
  )

  return currentLanguage || FALLBACK_LANGUAGE
}

function setLanguageFromDomain() {
  localStorage.setItem(LANGUAGE_KEY, getCurrentLanguageFromDomain())
}

function getCurrentLanguage() {
  return localStorage.getItem(LANGUAGE_KEY) || process.env.VUE_APP_DEFAULT_LOCALE
}

/** Step that runs the calculate API call (always the step right before Summary). */
function getCalculateStepName(language = getCurrentLanguage()) {
  const steps = LANGUAGE_CONFIG[language]?.steps ?? []
  const summaryIndex = steps.indexOf('SummaryStep')

  if (summaryIndex <= 0) {
    return null
  }

  return steps[summaryIndex - 1]
}

function isCalculateStep(stepName, language = getCurrentLanguage()) {
  return getCalculateStepName(language) === stepName
}

export {
  setLanguageFromDomain,
  getCurrentLanguageFromDomain,
  LANGUAGE_CONFIG,
  getCalculateStepName,
  isCalculateStep
}
